import ApiClient from './ApiClient';

class MotorReservaExtrasAPI extends ApiClient {
  constructor() {
    super('motor_reserva_extras', { accountScoped: true });
  }
}

export default new MotorReservaExtrasAPI();
